import TriggersEmpty from "../components/TriggersEmpty";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default function StopCallRecordingTriggersTable(props) {
  const { stopCallRecordingTriggers, onEdit, onDelete, showActions } = props;

  if (stopCallRecordingTriggers.length === 0) {
    return <TriggersEmpty />;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>Event name</TableHeader>
          {showActions && <TableHeader>Action</TableHeader>}
        </TableRow>
      </TableHead>
      <TableBody>
        {stopCallRecordingTriggers.map((item, index) => (
          <TableRow key={index}>
            <TableCell className="min-w-[400px] whitespace-normal">
              {item.actionName}
            </TableCell>
            {showActions && (
              <TableCell>
                <div className="flex flex-row gap-x-2">
                  <Button
                    outline
                    onClick={() => onEdit({ isOpen: true, item, index })}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    outline
                    onClick={() => onDelete({ isOpen: true, item, index })}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
